export default __webpack_public_path__ + "static/media/3.2dfd1f4f.jpg";